export const PAGE_LIST_FETCH = 'PAGE_LIST_FETCH';
export const PAGE_LIST_SUCCESS = 'PAGE_LIST_SUCCESS';
export const PAGE_LIST_FAILURE = 'PAGE_LIST_FAILURE';

export const DELETE_PAGE_FETCH = 'DELETE_PAGE_FETCH';
export const DELETE_PAGE_SUCCESS = 'DELETE_PAGE_SUCCESS';
export const DELETE_PAGE_FAILURE = 'DELETE_PAGE_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/PageList/actionTypes.js